/* ============================================
   GIGLIOTTO TENUTE — Wines Category Filter
   Only loaded on pages with wines-catalog.liquid
   ============================================ */

(function initFilters() {
  const pills   = document.querySelectorAll('.filter-pill');
  const cards   = document.querySelectorAll('.wine-card');
  const countEl = document.getElementById('wines-count');
  if (!pills.length) return;

  pills.forEach(pill => {
    pill.addEventListener('click', () => {
      pills.forEach(p => p.classList.remove('active'));
      pill.classList.add('active');

      const filter  = pill.dataset.filter;
      let   visible = 0;

      cards.forEach(card => {
        const match = filter === 'all' || card.dataset.category === filter;
        card.style.display = match ? '' : 'none';
        if (match) visible++;
      });

      if (countEl && window.wineStrings) {
        countEl.textContent = window.wineStrings.count.replace('{{ count }}', visible);
      }
    });
  });
})();
